import React from 'react';
import { cn } from '../../utils/cn';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'brand' | 'accent' | 'outline' | 'success' | 'warning';
}

export const Badge: React.FC<BadgeProps> = ({ className, variant = 'brand', children, ...props }) => {
  const variants = {
    brand: 'bg-[#4a82c2]/10 text-[#356aa5] dark:text-sky-400 border border-[#4a82c2]/30 font-semibold',
    accent: 'bg-[#08adae]/10 text-[#08adae] border border-[#08adae]/30 font-semibold',
    outline: 'bg-slate-100 dark:bg-slate-800/40 text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-slate-700/80',
    success: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30',
    warning: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/30',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full backdrop-blur-sm transition-colors',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};
